import styles from "./FilterChips.module.css";

type FilterChipsProps<Id extends string> = {
  label: string;
  options: readonly { id: Id; label: string }[];
  selected: Id;
  onSelect: (id: Id) => void;
};

export function FilterChips<Id extends string>({
  label,
  options,
  selected,
  onSelect,
}: FilterChipsProps<Id>) {
  return (
    <div role="group" aria-label={label} className={styles.chips}>
      {options.map(option => (
        <button
          key={option.id}
          type="button"
          className={styles.chip}
          aria-pressed={selected === option.id}
          onClick={() => onSelect(option.id)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
